import React from 'react';
import {useEffect, useState} from 'react';
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom';
import { API } from 'aws-amplify';
import AlertModal from '../../AlertModal'
import KeywordInfoCard from './KeywordInfoCard'
import NewsItemCard from './NewsItemCard'
import TopCategoriesCard from './TopCategoriesCard'
import MissingIcon from '../../../images/missing.jpg';
import PieCard from './PieCard'
import FilterTrendCard from './FilterTrendCard'
import AssociatedNotifItem from './AssociatedNotifItem'
import { getStorage, ref as storageRef, getDownloadURL } from "firebase/storage";

import DashboardCloudCard from '../DashboardCloudCard'

function TrendingContent({updateContentState, setAlertModalState, authToken}) {

  const storage = getStorage();
  const [entityKeywords, setEntityKeywords] = useState({});
  const [selectedKeyword, setSelectedKeyword] = useState('');
  const [keywordInfoData, setKeywordInfoData] = useState([]);
  const [associatedNotifs, setAssociatedNotifs] = useState([]);
  const [newsItemCards, setNewsItemCards] = useState([]);
  const [filterTrendData, setFilterTrendData] = useState({});

  const [emotions, setEmotions] = useState([]);
  const [tones, setTones] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [timeExpressions, setTimeExpressions] = useState([]);
  const [dates, setDates] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [abuses, setAbuses] = useState({});
  const [sarcasm, setSarcasm] = useState({});

  useEffect(() => {
    fetchEntityKeywordData()
    fetchEmotions()
    fetchQuestions()
    fetchTimeExpressions()
    fetchDates()
    fetchTasks()
    fetchAbuses()
    fetchSarcasm()
    fetchTones()
  }, [authToken]);

  function timeSince(timestamp) {
    var milliseconds = parseInt(timestamp)
    const dateObject = new Date(milliseconds)
    var seconds = Math.floor((new Date() - dateObject) / 1000);
    if(seconds<0)
      seconds = 0

    var interval = seconds / 31536000;

    if (interval > 1) {
      return Math.floor(interval) + " years ago";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " months";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days ago";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours ago";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " mins ago";
    }
    return Math.floor(seconds) + " secs ago";
  }

  function cleanTitle(n){
    if(n.title!='' && n.title!=undefined && n.title!='unknown')
      return n.title
    if(n.extraTitle!='' && n.extraTitle!=undefined && n.extraTitle!='unknown')
      return n.extraTitle
    return 'New message from '+n.appName
  }

  function filterAssociatedNotifs(filter, val){

    setFilterTrendData({})
    setAssociatedNotifs([])
    setKeywordInfoData([])
    setNewsItemCards([])

    filterFreqUsage(filter, val)

    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-associated-notifs',
        filt: filter,
        val: val
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {

          if('notifications' in response){
            var notifications = []
            for(var n of response['notifications']){
              n['extraText'] = ''
              n['appName'] = n.appname
              try {
                n['icon'] = await getDownloadURL(storageRef(storage, n.app + '.jpg'))
              } catch (e){
                n['icon'] = MissingIcon
              }
              n['title'] = cleanTitle(n)
              n['date'] = timeSince(n.id)

              notifications.push(n)
              notifications.sort(function (a, b) {
                return b.id > a.id ? 1 : -1
              })
            }
            setAssociatedNotifs(notifications.map((item) => {
              return (
                <AssociatedNotifItem
                  key={item.id}
                  id={item.id}
                  image={item.icon}
                  app={item.appName}
                  link={item.id}
                  title={item.title}
                  text={item.extraText}
                  date={item.date}
                  type={item.appName}
                  fav={item.id}
                />
              );
            }))
        }
        else{
          console.log('Associated notifications not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });

  }

  function filterFreqUsage(filter, val){

    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-freq-use',
        filt: filter,
        val: val
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('freq' in response){
          setFilterTrendData(response['freq'])
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });

  }

  function prepKeywordForQuery(keyword){
    return keyword.replace(/\s+/g, "+")
  }

  function lastWeekDate(){
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7).toISOString().split('.')[0];
  }

  async function fetchRecentNews(keyword){
    fetch("https://api.thenewsapi.com/v1/news/top?language=en&api_token="+ process.env.REACT_APP_THE_NEWS_API_TOKEN +
      "&search="+prepKeywordForQuery(keyword)+"&limit=5&published_after="+lastWeekDate())
      .then(res => res.json())
      .then(
        (result) => {
          try{
            if('data' in result)
              setNewsItemCards(result.data.map((item, index) => {
                return (
                  <NewsItemCard
                    id={item.uuid}
                    title={item.title}
                    textContent={item.description}
                    imageURL={item.image_url}
                    published={item.published_at}
                    link={item.url}
                  />
                );
              }))
          } catch (e) {
            console.log('Error getting news: ')
            console.log(e)
            setNewsItemCards([])
          }
        },
        (error) => {
          console.log(error)
          setNewsItemCards([])
        }
      )
  }

  async function fetchKeywordInfo(keyword){
    filterAssociatedNotifs('keywords', keyword)
    fetch("https://api.duckduckgo.com/?q="+prepKeywordForQuery(keyword)+"&skip_disambig=1&format=json&pretty=1&t=empushy")
      .then(res => res.json())
      .then(
        (result) => {
          try{
            var keywordInfoList = []
            if(result['Abstract'] !=''){
              var keywordInfo = {}
              keywordInfo['heading'] = result['Heading']
              keywordInfo['abstract'] = result['Abstract']
              keywordInfo['image'] = result['Image']
              keywordInfo['url'] = result['AbstractURL']
              keywordInfoList.push(keywordInfo)
            }
            if (result.hasOwnProperty('RelatedTopics')){
              for(var i=0; i<3 && i<result['RelatedTopics'].length; i++){
                if(!result['RelatedTopics'][i].hasOwnProperty('name')) {
                  var keywordInfo = {}
                  try{
                    if(result['Heading']=='')
                      keywordInfo['heading'] = result['RelatedTopics'][i]['FirstURL'].split('.com/')[1].replace('_', ' ')
                    else
                      keywordInfo['heading'] = result['Heading']
                  }
                  catch (e) {
                    keywordInfo['heading'] = keyword
                  }
                  keywordInfo['abstract'] = result['RelatedTopics'][i]['Text']
                  if(result['RelatedTopics'][i].hasOwnProperty('Icon'))
                    keywordInfo['image'] = result['RelatedTopics'][i]['Icon']['URL']
                  else
                    keywordInfo['image'] = ''
                  keywordInfo['url'] = result['RelatedTopics'][i]['FirstURL']
                  keywordInfoList.push(keywordInfo)
                }
              }
            }
            setKeywordInfoData(keywordInfoList)
          } catch (e) {
            console.log('Error converting keyword results: ')
            console.log(e)
            setKeywordInfoData([])
          }
          fetchRecentNews(keyword)
        },
        (error) => {
          console.log(error)
          setKeywordInfoData([])
        }
      )
  }

  async function fetchEntityKeywordData(){
    setEntityKeywords([])
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-entity-cloud'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('keywords' in response){
          setEntityKeywords(response['keywords'])
        }
        else{
          console.log('Top data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchEmotions(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-emotions'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('top' in response){
          setEmotions(response['top'])
        }
        else{
          console.log('Top data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchTones(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-tones'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
        .get(apiName, path, params)
        .then(async(response) => {
          if('top' in response){
            setTones(response['top'])
          }
          else{
            console.log('Top data not found.')
          }
        })
        .catch(error => {
          console.log('Error executing request.')
          console.log(error)
        });
  }

  async function fetchQuestions(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-questions'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('top' in response){
          setQuestions(response['top'])
        }
        else{
          console.log('Top data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchTimeExpressions(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-time'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('top' in response){
          setTimeExpressions(response['top'])
        }
        else{
          console.log('Top data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchDates(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-dates'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('top' in response){
          setDates(response['top'])
        }
        else{
          console.log('Top data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchTasks(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-tasks'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('top' in response){
          setTasks(response['top'])
        }
        else{
          console.log('Top data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchAbuses(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-abuse'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('pie' in response){
          setAbuses(response['pie'])
        }
        else{
          console.log('Pie data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchSarcasm(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-sarcasm'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('pie' in response){
          setSarcasm(response['pie'])
        }
        else{
          console.log('Pie data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  return (

    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full">

      <Helmet>
        <title>EmPushy | Content</title>
      </Helmet>

      {/* Page content */}
      <div className="max-w-full flex flex-col lg:flex-row lg:space-x-8 xl:space-x-16 ">
        {/* Content */}
        <div>
          <div className="mb-6">
            <ul className="inline-flex flex-wrap text-sm font-medium">
              <li className="flex items-center">
                <div className="text-slate-500 hover:text-pink-500 cursor-pointer"
                     onClick={()=>updateContentState('home')}>Home</div>
                <svg className="h-4 w-4 fill-current text-slate-400 mx-3" viewBox="0 0 16 16">
                  <path d="M6.6 13.4L5.2 12l4-4-4-4 1.4-1.4L12 8z" />
                </svg>
              </li>
              <li className="flex items-center">
                <a className="text-slate-500">Trending Content</a>
              </li>
            </ul>
          </div>
          <header className="mb-4">
            {/* Title */}
            <h1 className="text-2xl md:text-3xl text-slate-800 font-bold mb-2">Trending Content</h1>
            <p className="mb-6 text-justify">Wish you knew what to send to your audience? This guide highlights the most recent and common
              trends in marketing campaign content. Learn what keywords and emojis your audience is expecting.
              Craft messages with the right tone of voice and sentiment to ensure your campaigns are eye-catcing
              and successful!</p>
          </header>

          {/* Image */}
          <div className="mb-6">
            <DashboardCloudCard data={entityKeywords} title={'Trending Keywords'}
                                hint={'Most frequent words found in messages pushed in the past 7 days'}
                                keywordClicked={fetchKeywordInfo}/>
          </div>

          {/*<div className="flex flex-row mb-5 gap-6">
            <TopCategoriesCard title="Trending Topics" category="Topic" data={emotions} palette={2}
                               hint="Trending topics found in the text content of campaigns
                              (based on an analysis of campaigns pushed over the past 7 days)"/>
            <TopCategoriesCard title="Trending Call-to-actions" category="CTA" data={emotions} palette={3}
                               hint="Trending Call-to-actions found in the text content of campaigns
                              (based on an analysis of campaigns pushed over the past 7 days)"/>
          </div>*/}

          <div className="flex flex-wrap mb-5 gap-6">
            <div className="flex-1">
              <TopCategoriesCard title="Trending Emotion" category="Emotion" data={emotions} palette={0}
                                 hint="Trending use of emotion found in the text content of campaigns
                                (based on an analysis of campaigns pushed over the past 7 days)"
                                filterFunc={filterAssociatedNotifs}/>
            </div>
            <div className="flex-1">
              <TopCategoriesCard title="Trending Tone" category="Tone" data={tones} palette={1}
                               hint="Trending use of tone found in the text content of campaigns
                              (based on an analysis of campaigns pushed over the past 7 days)"
                               filterFunc={filterAssociatedNotifs}/>
            </div>
          </div>

          <div className="flex flex-wrap mb-5 gap-6">
            <div className="flex-1">
              <PieCard title="Abuse Detection" category="Abuse" data={abuses}
                                 hint="Abusive language detected in the text content of campaigns
                                (based on an analysis of campaigns pushed over the past 7 days)"
                                 palette={2} filterFunc={filterAssociatedNotifs}/>
            </div>
            <div className="flex-1">
              <PieCard title="Sarcasm Detection" category="Sarcasm" data={sarcasm}
                       hint="Sarcastic language detected in the text content of campaigns
                                (based on an analysis of campaigns pushed over the past 7 days)"
                       palette={2} filterFunc={filterAssociatedNotifs}/>
            </div>
          </div>

          <div className="flex flex-wrap mb-5 gap-6">
            <div className="flex-1">
              <TopCategoriesCard title="Trending Questions" category="Question" data={questions}
                               hint="Trending question types found in the text content of campaigns
                                (based on an analysis of campaigns pushed over the past 7 days)"
                                 palette={2} filterFunc={filterAssociatedNotifs}/>
            </div>
            <div className="flex-1">
              <TopCategoriesCard title="Time Expressions" category="Time" data={timeExpressions}
                               hint="Trending time expressions found in the text content of campaigns
                              (based on an analysis of campaigns pushed over the past 7 days)"
                               palette={3} filterFunc={filterAssociatedNotifs}/>
            </div>
          </div>

          <div className="flex flex-wrap mb-5 gap-6">
            <div className="flex-1">
              <TopCategoriesCard title="Trending Dates" category="Date" data={dates}
                                 hint="Trending date types found in the text content of campaigns
                                (based on an analysis of campaigns pushed over the past 7 days)"
                                 palette={0} filterFunc={filterAssociatedNotifs}/>
            </div>
            <div className="flex-1">
              <TopCategoriesCard title="Trending Tasks" category="Task" data={tasks}
                                 hint="Trending tasks found in the text content of campaigns
                              (based on an analysis of campaigns pushed over the past 7 days)"
                                 palette={1} filterFunc={filterAssociatedNotifs}/>
            </div>
          </div>


          {/* Post content */}
          {/*<div>
                      <h2 className="text-xl leading-snug text-slate-800 font-bold mb-2">Meetup Details</h2>
                      <p className="mb-6">In the world of AI, behavioural predictions are leading the charge to better machine learning.</p>
                      <p className="mb-6">
                        There is so much happening in the AI space. Advances in the economic sectors have seen automated business practices rapidly
                        increasing economic value. While the realm of the human sciences has used the power afforded by computational capabilities to
                        solve many human based dilemmas. Even the art scene has adopted carefully selected ML applications to usher in the technological
                        movement.
                      </p>
                      <p className="mb-6">
                        Join us every second Wednesday as we host an open discussion about the amazing things happening in the world of AI and machine
                        learning. Feel free to share your experiences, ask questions, ponder the possibilities, or just listen as we explore new topics
                        and revisit old ones.
                      </p>
                    </div>
                    <hr className="my-6 border-t border-slate-200" />*/}

        </div>

        {/* Sidebar */}
        <div className="flex-col space-y-4 hidden md:block">
          <div className="sticky overflow-y-scroll max-h-screen no-scrollbar pb-28">
            {/* 1st block (if keyword selected) */}
            <div className={`${keywordInfoData.length==0 && newsItemCards.length==0 && associatedNotifs.length==0
              ?'visible':'hidden'}`}>
              <p className="text-gray-400 text-justify">👈 Select a keyword or category from the charts to learn more about
              concepts, associated news items and similar campaigns 🔎</p>
            </div>
            <div className={`${keywordInfoData.length>0?'visible':'hidden'}`}>
              <KeywordInfoCard title='Keyword Definition' data={keywordInfoData} hint="Information regarding selected
                keyword"/>
            </div>
            <div className={`${filterTrendData.hasOwnProperty('values')?'visible':'hidden'} my-2`}>
              <FilterTrendCard data={filterTrendData}/>
            </div>

            {/* 2nd block (if keyword selected) */}
            <div className={`${associatedNotifs.length>0?'visible':'hidden'} rounded-sm lg:w-72 xl:w-80 py-2 my-2`}>
              <div className="text-sm text-gray-800 font-semibold w-full text-center mb-2 space-y-2">Associated Campaigns 🔔</div>
              {associatedNotifs}
              <div className="mt-2 mx-auto text-center">
                <button
                  className="btn bg-white border-gray-200 hover:border-gray-300
                text-gray-500 hover:text-gray-600 shadow-1"
                  onClick={() =>
                    setAlertModalState({title: 'Contact Us ✉', message: 'To access this feature and others which facilitate greater ' +
                        'in-depth analysis, please send us an email (hello@empushy.com) and we will add you to our exclusive beta group.'})
                  }>
                  Load more
                </button>
              </div>
            </div>
            {/* 3rd block (if keyword selected) */}
            <div className={`${newsItemCards.length>0?'visible':'hidden'} rounded-sm lg:w-72 xl:w-80`}>
              <div className="text-sm text-gray-800 font-semibold w-full text-center mb-2">Associated News 📰</div>
              {newsItemCards}
            </div>


            {/* 2nd block */}
            {/*<div className="bg-white p-5 shadow-1 rounded-sm border border-slate-200 lg:w-72 xl:w-80">
                        <div className="flex justify-between space-x-1 mb-5">
                          <div className="text-sm text-slate-800 font-semibold">Attendees (127)</div>
                          <a className="text-sm font-medium text-indigo-500 hover:text-indigo-600" href="#0">
                            View All
                          </a>
                        </div>
                        <ul className="space-y-3">
                          <li>
                            <div className="flex justify-between">
                              <div className="grow flex items-center">
                                <div className="relative mr-3">
                                  <img className="w-8 h-8 rounded-full" src={UserImage08} width="32" height="32" alt="User 08" />
                                </div>
                                <div className="truncate">
                                  <span className="text-sm font-medium text-slate-800">Carolyn McNeail</span>
                                </div>
                              </div>
                              <button className="text-slate-400 hover:text-slate-500 rounded-full">
                                <span className="sr-only">Menu</span>
                                <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">
                                  <circle cx="16" cy="16" r="2" />
                                  <circle cx="10" cy="16" r="2" />
                                  <circle cx="22" cy="16" r="2" />
                                </svg>
                              </button>
                            </div>
                          </li>
                          <li>
                            <div className="flex justify-between">
                              <div className="grow flex items-center">
                                <div className="relative mr-3">
                                  <img className="w-8 h-8 rounded-full" src={UserImage01} width="32" height="32" alt="User 01" />
                                </div>
                                <div className="truncate">
                                  <span className="text-sm font-medium text-slate-800">Dominik Lamakani</span>
                                </div>
                              </div>
                              <button className="text-slate-400 hover:text-slate-500 rounded-full">
                                <span className="sr-only">Menu</span>
                                <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">
                                  <circle cx="16" cy="16" r="2" />
                                  <circle cx="10" cy="16" r="2" />
                                  <circle cx="22" cy="16" r="2" />
                                </svg>
                              </button>
                            </div>
                          </li>
                          <li>
                            <div className="flex justify-between">
                              <div className="grow flex items-center">
                                <div className="relative mr-3">
                                  <img className="w-8 h-8 rounded-full" src={UserImage03} width="32" height="32" alt="User 03" />
                                </div>
                                <div className="truncate">
                                  <span className="text-sm font-medium text-slate-800">Ivan Mesaros</span>
                                </div>
                              </div>
                              <button className="text-slate-400 hover:text-slate-500 rounded-full">
                                <span className="sr-only">Menu</span>
                                <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">
                                  <circle cx="16" cy="16" r="2" />
                                  <circle cx="10" cy="16" r="2" />
                                  <circle cx="22" cy="16" r="2" />
                                </svg>
                              </button>
                            </div>
                          </li>
                          <li>
                            <div className="flex justify-between">
                              <div className="grow flex items-center">
                                <div className="relative mr-3">
                                  <img className="w-8 h-8 rounded-full" src={UserImage05} width="32" height="32" alt="User 05" />
                                </div>
                                <div className="truncate">
                                  <span className="text-sm font-medium text-slate-800">Maria Martinez</span>
                                </div>
                              </div>
                              <button className="text-slate-400 hover:text-slate-500 rounded-full">
                                <span className="sr-only">Menu</span>
                                <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">
                                  <circle cx="16" cy="16" r="2" />
                                  <circle cx="10" cy="16" r="2" />
                                  <circle cx="22" cy="16" r="2" />
                                </svg>
                              </button>
                            </div>
                          </li>
                        </ul>
                      </div>*/}

            {/* 3rd block */}
            {/*<div className="bg-white p-5 shadow-1 rounded-sm border border-slate-200 lg:w-72 xl:w-80">
                        <div className="flex justify-between space-x-1 mb-5">
                          <div className="text-sm text-slate-800 font-semibold">Invite Friends</div>
                          <a className="text-sm font-medium text-indigo-500 hover:text-indigo-600" href="#0">
                            View All
                          </a>
                        </div>
                        <ul className="space-y-3">
                          <li>
                            <div className="flex items-center justify-between">
                              <div className="grow flex items-center">
                                <div className="relative mr-3">
                                  <img className="w-8 h-8 rounded-full" src={UserImage02} width="32" height="32" alt="User 02" />
                                </div>
                                <div className="truncate">
                                  <span className="text-sm font-medium text-slate-800">Haruki Masuno</span>
                                </div>
                              </div>
                              <button className="text-xs inline-flex font-medium bg-indigo-100 text-indigo-600 rounded-full text-center px-2.5 py-1">
                                Invite
                              </button>
                            </div>
                          </li>
                          <li>
                            <div className="flex items-center justify-between">
                              <div className="grow flex items-center">
                                <div className="relative mr-3">
                                  <img className="w-8 h-8 rounded-full" src={UserImage04} width="32" height="32" alt="User 04" />
                                </div>
                                <div className="truncate">
                                  <span className="text-sm font-medium text-slate-800">Joe Huang</span>
                                </div>
                              </div>
                              <button className="text-xs inline-flex font-medium bg-indigo-100 text-indigo-600 rounded-full text-center px-2.5 py-1">
                                Invite
                              </button>
                            </div>
                          </li>
                          <li>
                            <div className="flex items-center justify-between">
                              <div className="grow flex items-center">
                                <div className="relative mr-3">
                                  <img className="w-8 h-8 rounded-full" src={UserImage06} width="32" height="32" alt="User 06" />
                                </div>
                                <div className="truncate">
                                  <span className="text-sm font-medium text-slate-800">Carolyn McNeail</span>
                                </div>
                              </div>
                              <button className="text-xs inline-flex font-medium bg-indigo-100 text-indigo-600 rounded-full text-center px-2.5 py-1">
                                Invite
                              </button>
                            </div>
                          </li>
                          <li>
                            <div className="flex items-center justify-between">
                              <div className="grow flex items-center">
                                <div className="relative mr-3">
                                  <img className="w-8 h-8 rounded-full" src={UserImage08} width="32" height="32" alt="User 08" />
                                </div>
                                <div className="truncate">
                                  <span className="text-sm font-medium text-slate-800">Lisa Sitwala</span>
                                </div>
                              </div>
                              <button className="text-xs inline-flex font-medium bg-indigo-100 text-indigo-600 rounded-full text-center px-2.5 py-1">
                                Invite
                              </button>
                            </div>
                          </li>
                        </ul>
                      </div>*/}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrendingContent;